/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditOtherProfessional from './EditOtherProfessional/index'
import InApp from './InApp/index'
import Lead from './Lead/index'
import Phones from './Phones/index'
import ProfileActions from './ProfileActions/index'
import ProfileData from './ProfileData/index'
import ProfileImage from './ProfileImage/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Search/Content/Profiles/Content/Profile"
  
}) {
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
  return (<React.Fragment
>
<EditOtherProfessional
  viewPath={`${viewPath}/EditOtherProfessional`}
/>
<Lead
  viewPath={`${viewPath}/Lead`}
/>
<div
  data-testid="Profile.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-1AREyJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Horizontal}`}
>
<ProfileImage
  viewPath={`${viewPath}/ProfileImage`}
/>
<div
  data-testid="Profile.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<ProfileData
  viewPath={`${viewPath}/ProfileData`}
/>
<div
  data-testid="Profile.Horizontal:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal1}`}
>
<ProfileActions
  viewPath={`${viewPath}/ProfileActions`}
/>
<InApp
  viewPath={`${viewPath}/InApp`}
/>
<Phones
  viewPath={`${viewPath}/Phones`}
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}